import React, { useEffect, useState } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import { trans } from "../../../../_providers/Translation"
import "../../../../assets/css/partials/status-diagram.css"
import "../../../../assets/css/partials/StoragePartsStats.css"
import { PieChart } from "@mui/x-charts"
import ContractorsList from "./ContractorsList"

export default function ContractorsChart({
  endpoint = "dashboard/storage-parts/stats",
  size = 220,
}) {
  const [state, setState] = useState({ loading: true, data: null })

  useEffect(() => {
    let mounted = true

    Api.get("dashboard/contractors")
      .then((res) => {
        if (!mounted) return
        const payload = res?.data ?? res
        setState({ loading: false, data: payload })
      })
      .catch((error) => {
        console.error("StoragePartsStats API Error:", error)
        if (mounted) setState({ loading: false, data: null })
      })
    return () => {
      mounted = false
    }
  }, [endpoint])

  const apiData = state.data || {}
  const statsData = Array.isArray(apiData.types_stats?.types)
    ? apiData.types_stats.types
    : []
  const recentParts = Array.isArray(apiData.overview?.contractors)
    ? apiData.overview.contractors
    : []

  return (
    <div className="storage-parts-stats-chart">
      <div className="head">
        <h3>{trans("nav.contractors")}</h3>
      </div>

      <hr />

      <div className="body">
        <div className="left">
          <h5>{trans("random.recentlyAdded")}</h5>
          <ContractorsList recentParts={recentParts} loading={state.loading} />
        </div>
        <div className="right">
          {state.loading ? (
            <Skeleton height={150} count={2} />
          ) : statsData.length === 0 ? (
            <div
              className="alert info"
              style={{
                width: "100%",
                marginBottom: "auto",
              }}
            >
              {trans("messages.noDataFound")}
            </div>
          ) : (
            <div className="bot">
              <div className="bot-top">
                <h5>Компании по тип</h5>
              </div>
              <div className="bot-chart">
                <PieChart
                  series={[
                    {
                      data: statsData.map((stat) => {
                        return {
                          id: stat.type_id,
                          value: stat.contractors_count || 0,
                          label: stat.type_name,
                          color: stat.color,
                        }
                      }),
                    },
                  ]}
                  width={size}
                  height={size}
                  margin={{ right: 0 }}
                  slotProps={{
                    legend: { hidden: true },
                  }}
                />
                <table>
                  <tbody>
                    {statsData.map((stat, idx) => {
                      return (
                        <tr key={stat.name || idx}>
                          <td>
                            <span style={{ backgroundColor: stat.color }}></span>
                          </td>
                          <td>
                            <b>{stat.type_name}</b>
                          </td>
                          <td>{stat.contractors_count}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
